// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AvailabilityDisplay {
  margin: 0 1rem;
  white-space: nowrap;
  width: 100%;
  height: 60px;
  display: flex;
  flex-direction: column;
  position: relative;
  border: none;
}
.AvailabilityDisplay .btn {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
.AvailabilityDisplay .btn .sv {
  font-weight: bold;
}
.AvailabilityDisplay .btn + .btn:not(:last-child) {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.AvailabilityDisplay .btn + .btn:not(:last-child) + .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.AvailabilityDisplay.extend-left {
  margin-right: 1rem;
  margin-left: 0;
}
.AvailabilityDisplay.extend-left .btn {
  border-radius: 0 var(--bs-border-radius) var(--bs-border-radius) 0;
}
.AvailabilityDisplay.extend-right {
  margin-left: 1rem;
  margin-right: 0;
}
.AvailabilityDisplay.extend-right .btn {
  border-radius: var(--bs-border-radius) 0 0 var(--bs-border-radius);
}
.AvailabilityDisplay.extend, .AvailabilityDisplay.extend-left.extend-right {
  margin: 0;
}
.AvailabilityDisplay.extend .btn, .AvailabilityDisplay.extend-left.extend-right .btn {
  border-radius: 0;
  border-left: none;
}
.AvailabilityDisplay .DisplayText {
  cursor: pointer;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.AvailabilityDisplay .DisplayText:first-of-type {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.AvailabilityDisplay .DisplayText:last-of-type {
  border-bottom-left-radius: inherit;
  border-bottom-right-radius: inherit;
}
.AvailabilityDisplay .DisplayText:hover {
  text-decoration: underline;
}
.AvailabilityDisplay .DisplayText {
  line-height: 0.8rem;
}
.AvailabilityDisplay .DisplayText > div,
.AvailabilityDisplay .DisplayText > div:hover {
  text-decoration: none;
  margin-top: 0.2rem;
  font-size: 0.85rem;
}
.AvailabilityDisplay.show-create-icon .btn:first-child:not(:last-child) {
  position: absolute;
  width: auto;
  height: auto;
  top: 0;
  right: 0;
  padding: 0 0.25rem;
  color: #fff;
}
.AvailabilityDisplay {
  --bs-alert-padding-x: 0;
  --bs-alert-padding-y: 0;
  --bs-alert-margin-bottom: 0;
}

.AddAvailabilityDisplay {
  cursor: pointer;
  color: #d8d1ca;
  height: 80px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: color 0.2s;
}
.AddAvailabilityDisplay:hover {
  color: var(--bs-primary);
}`, "",{"version":3,"sources":["webpack://./src/components/AvailabilityDisplay/styles.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;AACF;AAAE;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;AAEJ;AADI;EACE,iBAAA;AAGN;AADI;EACE,4BAAA;EACA,6BAAA;AAGN;AAFM;EACE,yBAAA;EACA,0BAAA;AAIR;AAAE;EACE,kBAAA;EACA,cAAA;AAEJ;AADI;EACE,kEAAA;AAGN;AAAE;EACE,iBAAA;EACA,eAAA;AAEJ;AADI;EACE,kEAAA;AAGN;AAAE;EAEE,SAAA;AACJ;AAAI;EACE,gBAAA;EACA,iBAAA;AAEN;AAEE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAAJ;AACI;EACE,+BAAA;EACA,gCAAA;AACN;AACI;EACE,kCAAA;EACA,mCAAA;AACN;AACI;EACE,0BAAA;AACN;AAjBE;EAmBE,mBAAA;AACJ;AAAI;;EAEE,qBAAA;EACA,kBAAA;EACA,kBAAA;AAEN;AAGI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;AADN;AApFA;EAwFE,uBAAA;EACA,uBAAA;EACA,2BAAA;AADF;;AAIA;EACE,eAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AADF;AAEE;EACE,wBAAA;AAAJ","sourcesContent":[".AvailabilityDisplay {\n  margin: 0 1rem;\n  white-space: nowrap;\n  width: 100%;\n  height: 60px;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  border: none;\n  .btn {\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    padding: 0;\n    .sv {\n      font-weight: bold;\n    }\n    + .btn:not(:last-child) {\n      border-bottom-left-radius: 0;\n      border-bottom-right-radius: 0;\n      + .btn {\n        border-top-left-radius: 0;\n        border-top-right-radius: 0;\n      }\n    }\n  }\n  &.extend-left {\n    margin-right: 1rem;\n    margin-left: 0;\n    .btn {\n      border-radius: 0 var(--bs-border-radius) var(--bs-border-radius) 0;\n    }\n  }\n  &.extend-right {\n    margin-left: 1rem;\n    margin-right: 0;\n    .btn {\n      border-radius: var(--bs-border-radius) 0 0 var(--bs-border-radius);\n    }\n  }\n  &.extend,\n  &.extend-left.extend-right {\n    margin: 0;\n    .btn {\n      border-radius: 0;\n      border-left: none;\n    }\n  }\n\n  .DisplayText {\n    cursor: pointer;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    &:first-of-type {\n      border-top-left-radius: inherit;\n      border-top-right-radius: inherit;\n    }\n    &:last-of-type {\n      border-bottom-left-radius: inherit;\n      border-bottom-right-radius: inherit;\n    }\n    &:hover {\n      text-decoration: underline;\n    }\n\n    line-height: 0.8rem;\n    > div,\n    > div:hover {\n      text-decoration: none;\n      margin-top: 0.2rem;\n      font-size: 0.85rem;\n    }\n  }\n\n  &.show-create-icon {\n    .btn:first-child:not(:last-child) {\n      position: absolute;\n      width: auto;\n      height: auto;\n      top: 0;\n      right: 0;\n      padding: 0 0.25rem;\n      color: #fff;\n    }\n  }\n  --bs-alert-padding-x: 0;\n  --bs-alert-padding-y: 0;\n  --bs-alert-margin-bottom: 0;\n}\n\n.AddAvailabilityDisplay {\n  cursor: pointer;\n  color: #d8d1ca; // @TODO: Darker secondary-subtle. Move to themes.scss\n  height: 80px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: color 0.2s;\n  &:hover {\n    color: var(--bs-primary);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
